import React from 'react';
import classes from 'assets/styles/CloseDays.module.css';
import CloseMonth from './CloseMonth';

const CloseDays = () => {
  return (
    <div className={classes.closeDaysContainer}>
        <h3 style={{
            color: 'var(--accent-color)',
            textAlign: 'center',
            marginBottom: '10px'
       }}>2025 အတွက်ပိတ်ရက်များ</h3>
        <CloseMonth month="January" />
        <hr style={{margin: '10px 0',borderColor: '#ffffff2e'}} />
        <CloseMonth month="March" />
        <hr style={{margin: '10px 0',borderColor: '#ffffff2e'}} />
        <CloseMonth month="April" />
        <hr style={{margin: '10px 0',borderColor: '#ffffff2e'}} />
        <CloseMonth month="May" />
        <hr style={{margin: '10px 0',borderColor: '#ffffff2e'}} />
        <CloseMonth month="June" />
        <hr style={{margin: '10px 0',borderColor: '#ffffff2e'}} />
        <CloseMonth month="August" />
        <hr style={{margin: '10px 0',borderColor: '#ffffff2e'}} />
        <CloseMonth month="September" />
        <hr style={{margin: '10px 0',borderColor: '#ffffff2e'}} />
        <CloseMonth month="October" />
        <hr style={{margin: '10px 0',borderColor: '#ffffff2e'}} />
        <CloseMonth month="December" />
    </div>
  )
}

export default CloseDays
